/* Kiesblok naamlampjes (snippets/ke-naamlamp-kiezer.liquid) */
(() => {
  const init = (root) => {
    if (root.dataset.keReady === 'true') return;
    root.dataset.keReady = 'true';

    const section = root.closest('[id^="ProductSection-"]') || document;
    const form = document.getElementById(root.dataset.formId);
    const nameInput = root.querySelector('[data-ke-name]');
    const count = root.querySelector('[data-ke-count]');
    const nameHelp = root.querySelector('[data-ke-name-help]');
    const error = root.querySelector('[data-ke-error]');
    const preview = root.querySelector('[data-ke-preview]');
    const dotGroup = root.querySelector('[data-ke-dot]');
    const fontInputs = Array.from(root.querySelectorAll('[data-ke-font]'));
    const colourGroup = root.querySelector('[data-ke-colour]');
    const colourError = root.querySelector('[data-ke-colour-error]');
    const colourRequired = !!(colourGroup && colourGroup.hasAttribute('data-ke-colour-required'));
    const spoedInput = root.querySelector('input[data-ke-spoed-variant]');
    const priceEl = section.querySelector('[data-product-price]');
    let basePrice = Number(root.dataset.keBasePrice);
    let priceNote = null;

    const formatMoney = (cents) =>
      window.theme && theme.Currency && theme.settings
        ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
        : '€' + (cents / 100).toFixed(2).replace('.', ',');

    // Met spoed: prijs op de pagina (en in de mobiele balk) direct inclusief de spoedprijs
    const updatePrice = () => {
      if (!spoedInput || !priceEl || !basePrice) return;
      const extra = spoedInput.checked ? Number(spoedInput.dataset.keSpoedPrice) : 0;
      priceEl.textContent = formatMoney(basePrice + extra);

      if (!priceNote) {
        priceNote = document.createElement('span');
        priceNote.className = 'ke-naamlamp__price-note';
        priceEl.insertAdjacentElement('afterend', priceNote);
      }
      priceNote.textContent = spoedInput.dataset.keSpoedNote || '';
      priceNote.hidden = !extra;
    };

    // De gewone variant-selects van het thema (verborgen) blijven de bron voor variant, prijs en foto
    const nativeSelect = (position) =>
      section.querySelector('select[data-variant-input][data-index="option' + position + '"]');

    const chosenFont = () => {
      const input = fontInputs.find((el) => el.checked);
      return input ? input.dataset.keFont : null;
    };

    const chosenMark = () => {
      if (!dotGroup || dotGroup.disabled) return '';
      const input = dotGroup.querySelector('input:checked');
      return input ? input.dataset.keDotMark : '';
    };

    const hasColour = () => !colourGroup || !!colourGroup.querySelector('input:checked');

    // Nog geen kleur gekozen: melding bij de kleuren en daarheen scrollen
    const checkColour = (scroll) => {
      if (!colourRequired || hasColour()) return true;
      colourError.hidden = false;
      if (scroll) colourGroup.querySelector('.ke-naamlamp__swatches').scrollIntoView({ block: 'center', behavior: 'smooth' });
      return false;
    };

    const updateChosenLabels = () => {
      root.querySelectorAll('fieldset').forEach((group) => {
        const label = group.querySelector('[data-ke-chosen]');
        const input = group.querySelector('input[data-ke-label]:checked');
        if (label && input) label.textContent = input.dataset.keLabel;
      });
    };

    const updateDotGroup = () => {
      if (!dotGroup) return;
      const name = nameInput.value;
      const show = chosenFont() === 'emily' && (name.trim() === '' || /[ij]/.test(name));
      dotGroup.hidden = !show;
      dotGroup.disabled = !show;
    };

    const updatePreview = () => {
      if (!preview) return;
      const font = chosenFont();
      const name = nameInput.value.trim();
      const text = name || 'Mika';
      const mark = chosenMark();
      // Emily's Candy heeft zelf hartjes op de i en j; bij een gewone punt of sterretje tekenen we die zelf
      const ownDots = font === 'emily' && mark !== '♥';

      preview.className = 'ke-naamlamp__preview-name' + (font ? ' ke-font--' + font : '') + (name ? '' : ' is-empty');
      preview.textContent = '';

      Array.from(text).forEach((char) => {
        if (ownDots && (char === 'i' || char === 'j')) {
          const letter = document.createElement('span');
          letter.className = 'ke-naamlamp__dot-letter ke-naamlamp__dot-letter--' + char;
          letter.textContent = char === 'i' ? 'ı' : 'j';
          const anchor = document.createElement('span');
          anchor.className = 'ke-naamlamp__dot-anchor';
          anchor.setAttribute('aria-hidden', 'true');
          const dot = document.createElement('span');
          dot.className = mark ? 'ke-naamlamp__dot-mark' : 'ke-naamlamp__dot-round';
          dot.textContent = mark;
          anchor.appendChild(dot);
          letter.appendChild(anchor);
          preview.appendChild(letter);
        } else {
          preview.appendChild(document.createTextNode(char));
        }
      });
    };

    // Laatste controle boven aantal en knop: alle keuzes op één regel, wat nog ontbreekt valt op
    const summary = root.querySelector('[data-ke-summary]');
    if (summary) {
      const quantity = section.querySelector('.product__quantity');
      const anchor = (quantity && quantity.closest('.product-block')) || (form && form.closest('.product-block'));
      if (anchor) {
        anchor.parentElement.insertBefore(summary, anchor);
        summary.hidden = false;
      }
    }

    const updateSummary = () => {
      if (!summary || summary.hidden) return;
      const parts = [];
      const add = (text, missing) => parts.push({ text, missing });

      const themeInput = root.querySelector('input[data-ke-media-id]:checked');
      if (themeInput) add(themeInput.dataset.keLabel);

      const fontInput = fontInputs.find((el) => el.checked);
      if (fontInput) add(fontInput.nextElementSibling.textContent.trim());

      if (colourGroup) {
        const colourInput = colourGroup.querySelector('input:checked');
        if (colourInput) add(colourInput.dataset.keLabel.split(',')[0].toLowerCase());
        else add(summary.dataset.colourMissing, true);
      }

      const name = nameInput.value.trim();
      if (name) {
        let text = '“' + name + '”';
        const dot = dotGroup && !dotGroup.disabled ? dotGroup.querySelector('input:checked') : null;
        if (dot && dot.dataset.keDotMark) text += ' (' + dot.nextElementSibling.textContent.trim().toLowerCase() + ')';
        add(text);
      } else {
        add(summary.dataset.nameMissing, true);
      }

      const delivery = root.querySelector('input[name="properties[levertijd]"]:checked');
      add(delivery && delivery.value.includes('spoed') ? summary.dataset.express : summary.dataset.standard);

      summary.textContent = '';
      const label = document.createElement('strong');
      label.textContent = summary.dataset.label + ': ';
      summary.appendChild(label);
      parts.forEach((part, index) => {
        if (index) summary.appendChild(document.createTextNode(', '));
        const span = document.createElement('span');
        span.textContent = part.text;
        if (part.missing) span.className = 'is-missing';
        summary.appendChild(span);
      });
    };

    const updateName = () => {
      count.textContent = nameInput.value.length + '/' + nameInput.maxLength;
      // Vol: de browser kapt verder typen stil af, dus teller en "Maximaal .. tekens" vallen dan op
      const full = nameInput.value.length >= nameInput.maxLength;
      count.classList.toggle('is-full', full);
      if (nameHelp) nameHelp.classList.toggle('is-full', full);
      if (nameInput.value.trim()) {
        nameInput.classList.remove('is-invalid');
        error.hidden = true;
      }
      updateDotGroup();
      updatePreview();
      updateSummary();
    };

    // Varianten zonder eigen foto (Zwaantjes, Courier Bold): toon de foto van het gekozen thema
    const showThemePhoto = () => {
      const themeInput = root.querySelector('input[data-ke-media-id]:checked');
      if (!themeInput || !themeInput.dataset.keMediaId) return;
      const thumb = section.querySelector('.product__thumb[data-id="' + themeInput.dataset.keMediaId + '"]');
      if (thumb) thumb.click();
    };

    root.addEventListener('change', (event) => {
      const input = event.target;

      if (input.dataset.keOption) {
        const select = nativeSelect(input.dataset.keOption);
        if (select && select.value !== input.value) {
          select.value = input.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateChosenLabels();
      }

      if (colourError && hasColour()) colourError.hidden = true;

      updateDotGroup();
      updatePreview();
      updatePrice();
      updateSummary();
    });

    nameInput.addEventListener('input', updateName);

    document.addEventListener('variant:change', (event) => {
      const colourOpen = colourRequired && !hasColour();
      root.querySelectorAll('input[data-ke-option]').forEach((input) => {
        // Kleur blijft leeg tot de klant er zelf een kiest
        if (colourOpen && colourGroup.contains(input)) return;
        const select = nativeSelect(input.dataset.keOption);
        if (select) input.checked = select.value === input.value;
      });
      updateChosenLabels();
      updateDotGroup();
      updatePreview();
      updateSummary();

      const variant = event.detail && event.detail.variant;
      if (variant) {
        basePrice = variant.price;
        updatePrice();
      }
      if (variant && !variant.featured_media) showThemePhoto();
    });

    // Lege naam: eigen Nederlandse melding in plaats van de browserballon
    nameInput.addEventListener('invalid', (event) => {
      event.preventDefault();
      nameInput.classList.add('is-invalid');
      error.hidden = false;
      // Kleur staat boven de naam: ontbreekt die ook, dan eerst daarheen
      if (checkColour(true)) {
        nameInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
        nameInput.focus({ preventScroll: true });
      }
    });

    // Spaties alleen tellen niet als naam; zonder gekozen kleur gaat er niets de winkelwagen in
    if (form) {
      form.addEventListener('submit', (event) => {
        if (!checkColour(true)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (nameInput.value.trim() === '') {
          nameInput.value = '';
          updateName();
          if (!nameInput.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }
      }, true);
    }

    // Spoed: het verborgen spoedproduct gaat mee de winkelwagen in (één per winkelwagen),
    // daarna pas mag de winkelwagenlade openen en opbouwen
    const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const addSpoed = async () => {
      const variantId = Number(spoedInput.dataset.keSpoedVariant);
      const cart = await fetch(cartRoot + 'cart.js').then((response) => response.json());
      if (cart.items.some((item) => item.variant_id === variantId)) return;

      await fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
    };

    if (form && spoedInput) {
      form.addEventListener('ajaxProduct:added', (event) => {
        if ((event.detail && event.detail.keSpoedDone) || !spoedInput.checked) return;
        event.stopPropagation();

        addSpoed()
          .catch(() => {})
          .finally(() => {
            form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: Object.assign({}, event.detail, { keSpoedDone: true }),
              bubbles: true
            }));
          });
      });
    }

    updateChosenLabels();
    updateName();
  };

  const run = () => document.querySelectorAll('[data-ke-naamlamp]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
